export default function queriesCompletedText(value) {
  const completedStatus = ['done', 'error', 'expired'];

  const total = value.length;
  const completed = value
    .filter((detail) => completedStatus.includes(detail.status))
    .length;

  return `${completed} de ${total} concluída${total > 1 ? 's' : ''}`;
}
